import React from 'react'

type Props = {
    onClick: () => void
}

/** Button for closing a window
 *
 * Not implemented:
 * * Disabled state
 * * Small size
 *
 * See:
 * * https://www.figma.com/design/BpMdzCsfZAXmpHQCowcsWD/Global-Design-Library-(Master-%40-7f17203)?node-id=520-13472&t=u4J7bvteUS9PcYvc-4
 * * CloseWindowButton.stories.tsx
 */

export function CloseWindowButton({ onClick }: Props) {
    return (
        <button className={'AppCore_ui_CloseWindowButton'} onClick={onClick}>
            <zaptic-icon icon-name={'cross'} />
        </button>
    )
}
